import React from 'react'
import PropTypes from 'prop-types'
import Activity from './Activity'
import TaskActivity from './Task'
import MeetingActivity from './Meeting'
import Note from './Note'

function ActivityType ({ activityType, component, componentProps, ...rest }) {
  if (component) {
    return React.cloneElement(component, {
      ...rest,
      ...(componentProps || {})
    })
  }
  if (!activityType) {
    return <Activity {...rest} />
  }
  switch (activityType.toLowerCase()) {
    case 'activity':
      return <Activity {...rest} />
    case 'task':
      return <TaskActivity {...rest} />
    case 'meeting':
      return <MeetingActivity {...rest} />
    case 'note':
      return <Note {...rest} />
    default:
      return <Activity {...rest} />
  }
}

ActivityType.propTypes = {
  activityType: PropTypes.string,
  component: PropTypes.node,
  componentProps: PropTypes.object
}

export default ActivityType
